import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const cardWrapper = css`
    display: flex;
    align-items: center;
    width: 100%;

    > div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;
export const EmptySearchSvg = styled.img`
    width: 300px;
`;

export const CardContent = styled.div<{ alignItems?: string }>`
    display: flex;
    flex-direction: column;
    align-items: ${({ alignItems }) => alignItems ?? "center"};
    justify-content: center;

    text-align: center;
`;
